<template>
  <div id="double-section-layout">
    <div id="voltar">
      <h4>Editar Encontros Atividade</h4>
      <button @click.prevent="fecharModal()">
        <img src="@/assets/Frame 523.png" />
      </button>
    </div>
    <section id="double-section-forms">
      <form class="form lado-esquerdo">
        <div id="campos-form-container">
          <h4>Informações do Encontro</h4>
          <div id="campos-form">
            <div class="encontro">
              <div class="mb-3">
                <div class="label-container">
                  <label
                    for="titulo"
                    class="form-label"
                    >Titulo *</label
                  >
                </div>

                <input
                  type="text"
                  id="titulo"
                  class="form-control"
                  v-model="encontroAtual.titulo"
                  required
                />
              </div>

              <div class="mb-3">
                <div class="label-container">
                  <label
                    for="descricao"
                    class="form-label"
                    >Descrição*</label
                  >
                </div>

                <input
                  type="text"
                  id="descricao"
                  class="form-control"
                  v-model="encontroAtual.descricao"
                  required
                />
              </div>

              <section id="datas">
                <div class="mb-3">
                  <div class="label-container">
                    <label
                      for="horario-inicio"
                      class="form-label"
                      >Data inicio*</label
                    >
                  </div>

                  <input
                    type="datetime-local"
                    id="horario-inicio"
                    class="form-control"
                    v-model="encontroAtual.inicio_periodo"
                    :min="dataMinima"
                    required
                  />
                </div>

                <div class="mb-3">
                  <div class="label-container">
                    <label class="form-label">Duração*</label>
                  </div>

                  <div style="display: flex; gap: 10px; align-items: center">
                    <input
                      type="number"
                      class="form-control"
                      min="1"
                      placeholder="Horas"
                      style="width: 100px"
                      v-model="encontroAtual.duracaoHoras"
                      :disabled="!encontroAtual.inicio_periodo"
                      required
                    />
                    <span>h</span>

                    <input
                      type="number"
                      class="form-control"
                      min="0"
                      max="59"
                      placeholder="Minutos"
                      v-model="encontroAtual.duracaoMinutos"
                      :disabled="!encontroAtual.inicio_periodo"
                      style="width: 120px"
                      required
                    />
                    <span>min</span>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div
          id="botoes"
          style="justify-content: center"
        >
          <button
            v-if="encontroAtual.titulo"
            id="enviar"
            type="submit"
            @click.prevent="atualizarEncontros()"
            class="btn btn-primary center"
          >
            Confirmar {{ editandoEncontro ? "edição" : "cadastro" }} de encontro
          </button>
          <button
            id="excluir"
            @click.prevent="cancelarEdicao()"
            v-if="editandoEncontro"
          >
            Cancelar edição
          </button>
          <button
            id="salvar"
            @click.prevent="$emit('editar-atividade')"
          >
            Editar Atividade
          </button>
        </div>
      </form>
      <form class="form lado-direito">
        <h4>Encontros Adicionados</h4>
        <div id="lista-encontros">
          <div
            class="encontro-item"
            v-for="(encontro, index) in encontrosAtividade"
            :key="index"
          >
            <div class="informacoes-encontro">
              <h5>
                {{ encontro.titulo }} • {{ formatarEnum(encontro.status) }}
              </h5>
              <p>{{ encontro.descricao }}</p>
              <p class="data-encontro">
                {{ formatarDataHora(encontro.inicio_periodo) }}
                -
                {{ formatarDataHora(encontro.fim_periodo) }}
              </p>
            </div>

            <button
              class="editar-encontro"
              @click="editarEncontro(encontro, index)"
              type="button"
              v-if="
                encontro.status !== 'FINALIZADO' &&
                encontro.status !== 'CANCELADO' &&
                encontro.status !== 'EM_EXECUCAO'
              "
            >
              Editar
            </button>

            <div class="excluir-encontro">
              <button
                @click="excluirEncontro(index)"
                class="excluir"
                type="button"
              >
                Excluir
              </button>
              <button
                @click="cancelarEncontro(encontro)"
                class="cancelar"
                type="button"
                v-if="
                  encontro.status !== 'FINALIZADO' &&
                  encontro.status !== 'CANCELADO' &&
                  encontro.status !== 'EM_EXECUCAO'
                "
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import HelpIcon from "@/components/common/HelpIcon.vue";
import encontrosService from "@/service/encontrosService";
import {
  formatarDataHora,
  formatarEnum,
  formatarParaInputDateTimeLocal,
} from "@/utils/FormatarEntradas";
import { useRoute } from "vue-router";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import router from "@/router";

dayjs.extend(utc);
dayjs.extend(timezone);

function toUTC(date) {
  if (!date) return null;
  return dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
}

export default {
  props: {
    dadosAtividade: {
      type: Object,
      required: false,
    },
    atividadeId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      mostrarAdicionados: false,
      mostrarEditados: false,
      indiceEncontroSelecionado: null,
      encontrosAtividade: [],
      encontroAtual: {},
      encontroOriginal: {}, // Guardar o encontro antes de editar
      editandoEncontro: false,
      dataMinima: null,
      minDateTime: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16),
      route: useRoute(),
      atividadeId: null,
      textosAjuda: [
        "Informe um título claro e objetivo para o encontro.",
        "Data de início do encontro.",
        "Data do fim do encontro.",
      ],
    };
  },
  components: {
    HelpIcon,
  },
  methods: {
    formatarParaInputDateTimeLocal,
    formatarDataHora,
    formatarEnum,
    useRoute,

    fecharModal() {
      router.back();
    },

    LimparDados() {
      this.encontrosAdicionados = [];
      this.encontrosEditados = [];
      this.encontrosNaoEditados = [];
    },

    editarEncontro(encontro, index) {
      // Verificar se o encontro está em execução
      if (encontro.status === "EM_EXECUCAO") {
        alert(
          "Não é possível editar um encontro que está acontecendo no momento."
        );
        return;
      }

      if (!this.verificacaoCampos()) {
        // Guardar uma cópia profunda do encontro original
        this.encontroOriginal = JSON.parse(JSON.stringify(encontro));

        this.encontroAtual = encontro;

        // Remover da lista sem mostrar alerta (apenas remove do array, não excluir do backend)
        this.encontrosAtividade.splice(index, 1);

        this.encontroAtual = this.calcularDuracao(this.encontroAtual);
        this.editandoEncontro = true;
      } else {
        alert("Conclua a edição do encontro atual antes de editar outro.");
      }
    },

    resetarEncontroAtual() {
      this.encontroAtual = {
        titulo: "",
        descricao: "",
        inicio_periodo: "",
        duracao: "00:00",
        duracaoHoras: 0,
        duracaoMinutos: 0,
        fim_periodo: "",
      };
    },

    async cancelarEdicao() {
      // Se tinha um encontro original sendo editado, restaurar para a lista
      if (Object.keys(this.encontroOriginal).length > 0) {
        this.encontrosAtividade.push(this.encontroOriginal);
      }

      this.resetarEncontroAtual();
      this.encontroOriginal = {};
      this.editandoEncontro = false;
      await this.carregarEncontros(this.atividadeId);
    },

    calcularDuracao(encontro) {
      const dataInicio = new Date(encontro.inicio_periodo);
      const dataFim = new Date(encontro.fim_periodo);

      // Calcula a diferença em milissegundos
      const diffMs = dataFim - dataInicio;

      if (diffMs < 0) {
        return "Data de fim deve ser posterior à data de início";
      }

      // Converte para minutos totais
      const minutosTotais = Math.floor(diffMs / (1000 * 60));

      // Extrai as horas e os minutos restantes
      encontro.duracaoHoras = Math.floor(minutosTotais / 60);
      encontro.duracaoMinutos = minutosTotais % 60;

      return encontro;
    },

    async cadastrarEncontro() {
      this.encontroAtual = this.atualizarDataFinal(this.encontroAtual);

      const payloadEncontro = {
        ...this.encontroAtual,
        inicio_periodo: toUTC(this.encontroAtual.inicio_periodo),
        fim_periodo: toUTC(this.encontroAtual.fim_periodo),
      };

      await encontrosService.postUmEncontro(this.atividadeId, payloadEncontro);

      this.resetarEncontroAtual();

      await this.carregarEncontros(this.atividadeId);
    },

    async excluirEncontro(index) {
      const confirmacao = confirm(
        "você tem certeza que deseja excluir esse encontro?"
      );

      if (confirmacao) {
        const encontro = this.encontrosAtividade[index];

        await encontrosService.deletEncontro(encontro.encontroId);
        await this.carregarEncontros(this.atividadeId);
      }
    },

    async cancelarEncontro(encontro) {
      const idEncontro = encontro.encontroId;
      const confirmacao = confirm(
        `você está prestes a cancelar o encontro: "${encontro.titulo}"" tem certeza dessa decisão?`
      );
      if (confirmacao) {
        const motivo = prompt(
          "Digite o motivo do cancelamento do encontro(Opcional)"
        );

        await encontrosService.cancelarEncontro(idEncontro, motivo); //Cancela um encontro
      }

      await this.carregarEncontros(this.atividadeId);
    },

    async atualizarEncontros() {
      // Validar campos obrigatórios
      if (!this.encontroAtual.titulo?.trim()) {
        alert("Título é obrigatório");
        return;
      }

      if (!this.encontroAtual.descricao?.trim()) {
        alert("Descrição é obrigatória");
        return;
      }

      if (!this.encontroAtual.inicio_periodo) {
        alert("Data de início é obrigatória");
        return;
      }

      if (
        !this.encontroAtual.duracaoHoras &&
        !this.encontroAtual.duracaoMinutos
      ) {
        alert("Duração é obrigatória");
        return;
      }

      // Atualizar data final antes de enviar
      this.encontroAtual = this.atualizarDataFinal(this.encontroAtual);

      // Validar que data final foi calculada
      if (!this.encontroAtual.fim_periodo) {
        alert("Erro ao calcular data final do encontro");
        return;
      }

      try {
        if (this.editandoEncontro) {
          // Comparar encontro original com o atual
          const encontroModificado =
            JSON.stringify(this.encontroAtual) !==
            JSON.stringify(this.encontroOriginal);

          if (encontroModificado) {
            this.encontrosAtividade.push(this.encontroOriginal);
          }

          // Atualizar o encontro no backend
          const encontroId = this.encontroAtual.encontroId;
          const payloadEncontro = {
            ...this.encontroAtual,
            inicio_periodo: toUTC(this.encontroAtual.inicio_periodo),
            fim_periodo: toUTC(this.encontroAtual.fim_periodo),
          };
          await encontrosService.putEncontro(encontroId, payloadEncontro);
          alert("Encontro atualizado com sucesso!");
        } else {
          // Novo encontro
          const payloadEncontro = {
            ...this.encontroAtual,
            inicio_periodo: toUTC(this.encontroAtual.inicio_periodo),
            fim_periodo: toUTC(this.encontroAtual.fim_periodo),
          };
          await encontrosService.postUmEncontro(
            this.atividadeId,
            payloadEncontro
          );
          alert("Encontro cadastrado com sucesso!");
        }

        this.resetarEncontroAtual();
        this.encontroOriginal = {};
        this.editandoEncontro = false;
        await this.carregarEncontros(this.atividadeId);
      } catch (error) {
        console.error("Erro ao salvar encontro:", error);
        alert("Erro ao salvar encontro: " + error.message);
      }
    },

    processImage(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          this.encontroDados.imagem.mimeType = file.type;
          this.encontroDados.imagem.base64Data = reader.result.split(",")[1];
        };
        reader.onerror = () => alert("Erro ao processar a imagem.");
        reader.readAsDataURL(file);
      }
    },

    atualizarDataMinima() {
      const encontros = Array.from(this.encontrosAtividade);

      this.dataMinima = encontros[encontros.length - 1]?.fim_periodo;
    },

    atualizarDuracao(encontro) {
      const h = String(encontro.duracaoHoras || 0).padStart(2, "0");
      const m = String(encontro.duracaoMinutos || 0).padStart(2, "0");
      encontro.duracao = `${h}:${m}`;
      return encontro;
    },

    atualizarDataFinal(encontro) {
      // Validar campos obrigatórios
      if (!encontro.inicio_periodo) {
        console.warn("Data de início não definida");
        return encontro;
      }

      // Garantir que duração está atualizada
      encontro = this.atualizarDuracao(encontro);

      // Validar duração
      if (!encontro.duracao || encontro.duracao === "00:00") {
        console.warn("Duração não definida ou é zero");
        return encontro;
      }

      // Parsear duração de forma segura
      const duracaoParts = encontro.duracao.split(":");
      if (duracaoParts.length !== 2) {
        console.error("Formato de duração inválido");
        return encontro;
      }

      const horas = parseInt(duracaoParts[0], 10) || 0;
      const minutos = parseInt(duracaoParts[1], 10) || 0;

      // Calcular data final
      try {
        let novaData = dayjs(encontro.inicio_periodo)
          .add(horas, "hour")
          .add(minutos, "minute");

        encontro.fim_periodo = novaData.format("YYYY-MM-DDTHH:mm");
      } catch (error) {
        console.error("Erro ao calcular data final:", error);
      }

      return encontro;
    },

    async carregarEncontros(atividadeId) {
      const resposta = await encontrosService.getEncontros(0, 50, atividadeId);
      if (resposta) {
        resposta.forEach((encontro) => {
          if (encontro.inicio_periodo) {
            encontro.inicio_periodo = this.formatarParaInputDateTimeLocal(
              encontro.inicio_periodo
            );
          }
          if (encontro.fim_periodo) {
            encontro.fim_periodo = this.formatarParaInputDateTimeLocal(
              encontro.fim_periodo
            );
          }
        });
      }
      this.encontrosAtividade = resposta || [];
    },

    verificacaoCampos() {
      return (
        this.encontroAtual.titulo ||
        this.encontroAtual.descricao ||
        this.encontroAtual.inicio_periodo ||
        this.encontroAtual.fim_periodo
      );
    },
  },

  async mounted() {
    this.atividadeId =
      this.route.query.atividade ||
      this.route.query.atividadeId ||
      this.atividadeId ||
      this.dadosAtividade?.id;

    // Inicializar encontroAtual com valores padrão
    this.resetarEncontroAtual();

    await this.carregarEncontros(this.atividadeId);
    this.atualizarDataMinima();
  },
};
</script>

<style scoped>
#excluir {
  background-color: red;
  border-color: red;
  color: white;
}

#double-section-layout > #voltar {
  width: 100%;
}

#tipo-edicao {
  display: flex;
  width: 80%;
  justify-content: space-around;
}

.edicao-encontro {
  margin-top: 2%;
  width: 45%;
  background-color: white;
  border: 2px solid #6f319e;
  border-radius: 20px;
}

.edicoes {
  display: flex;
  width: 100%;
  border-bottom: 2px solid black;
  margin-bottom: 2%;
  padding-bottom: 2%;
}

.edicoes button {
  background-color: white;
  border-radius: 20px;
  margin-left: 5%;
}

.edicoes button:active {
  background-color: #6f319e;
  color: white;
}

.edicoes h5 {
  margin: 0;
}

#tipo-edicao button:active {
  background-color: #6f319e;
  color: white;
}

.encontro {
  width: 100%;
}

#botoes button {
  width: auto;
}

.ajuda {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#lista-encontros {
  width: 100%;
  max-height: 350px;
  overflow-y: auto;
  margin-top: 1rem;
  padding-right: 5px;
}

#lista-encontros::-webkit-scrollbar {
  width: 6px;
}

#lista-encontros::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

#lista-encontros::-webkit-scrollbar-thumb {
  background: #6f319e;
  border-radius: 10px;
}

#lista-encontros::-webkit-scrollbar-thumb:hover {
  background: #5a2680;
}

/* ============ CARDS DE ENCONTRO ============ */
.encontro-item {
  display: flex;
  position: relative;
  align-items: center;
  background-color: #eee0f2;
  width: 100%;
  border-radius: 25px;
  min-height: 120px;
  margin: 10px 0;
  padding: 25px 15px;
  padding-right: 50px;
}

.informacoes-encontro {
  flex: 1;
  padding-right: 10px;
}

.informacoes-encontro h5 {
  margin: 0 0 8px 0;
  color: #6f319e;
  font-weight: 600;
  font-size: 1.1rem;
  word-break: break-word;
}

.informacoes-encontro p {
  margin: 0 0 5px 0;
  color: #00000080;
  font-size: 0.95rem;
  word-break: break-word;
}

.data-encontro {
  font-size: 0.85rem !important;
  font-weight: 500;
  color: #6f319e !important;
  margin-top: 8px !important;
}

/* ============ BOTÕES DE AÇÃO DO ENCONTRO ============ */
.editar-encontro,
.excluir-encontro {
  position: absolute;
  color: white;
  border: none;
  padding: 8px 20px;
  font-size: 0.9rem;
  transition: opacity 0.2s ease;
}

.editar-encontro {
  bottom: 0;
  right: 0;
  background-color: #6f319e;
  border-radius: 20px 0 20px 0;
}

.editar-encontro.desabilitado {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #ccc;
}

.editar-encontro:hover:not(.desabilitado) {
  opacity: 0.9;
}

.excluir-encontro {
  top: 0;
  right: 0;
  border-radius: 0 20px 0 20px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0;
  background-color: #ff0000;
}

.excluir-encontro button {
  width: 100%;
  padding: 8px 20px;
  color: white;
  border: none;
  background-color: transparent;
}

.cancelar {
  background-color: gray !important;
  border-radius: 0 20px 0 20px;
  border-left: 2px solid white !important;
}

.form-control {
  border: 2px solid var(--roxo-claro) !important;
}

.form-control:focus {
  border-color: #5b3fa8 !important;
  box-shadow: 0 0 0 2px rgba(91, 63, 168, 0.12) !important;
}
</style>
